import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mt-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_dynamic_html = _resolveComponent("g-dynamic-html");
    return (_ctx.element.content)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
                class: _normalizeClass(_ctx.cssClasses)
            }, [
                _createVNode(_component_g_dynamic_html, {
                    template: _ctx.element.content
                }, null, 8, ["template"])
            ], 2)
        ]))
        : _createCommentVNode("", true);
}
